import type {ReactNode} from 'react'

interface HistoryEntryProps {
    children: ReactNode
    'data-testid'?: string
}

/**
 * Bordered background-tinted row used for timeline/history entries — icon or
 * dot on the left, multi-line content on the right. Paired inside a vertical
 * `Stack` to build an event log.
 */
export function HistoryEntry({children, 'data-testid': testId}: HistoryEntryProps) {
    return (
        <div className="flex items-start gap-3 text-sm bg-background p-2 rounded border" data-testid={testId}>
            {children}
        </div>
    )
}
